export const CampaignType = {
  None: 0,
  Default: 0b1,
  Shopping: 0b10,
  DynamicSearchAds: 0b100,
  Audience: 0b1000,
  Smart: 0b10000,
  Hotel: 0b100000,
  PerformanceMax: 0b1000000,
  App: 0b10000000,
  LinkedIn: 0b100000000,
  All: 0xFFFF,
};

export const CampaignTypeByEnumValue = {
  "Enum.CampaignType'Default'": CampaignType.Default,
  "Enum.CampaignType'Shopping'": CampaignType.Shopping,
  "Enum.CampaignType'DynamicSearchAds'": CampaignType.DynamicSearchAds,
  "Enum.CampaignType'Audience'": CampaignType.Audience,
  "Enum.CampaignType'Smart'": CampaignType.Smart,
  "Enum.CampaignType'Hotel'": CampaignType.Hotel,
  "Enum.CampaignType'PerformanceMax'": CampaignType.PerformanceMax,
  "Enum.CampaignType'App'": CampaignType.App,
  "Enum.CampaignType'LinkedIn'": CampaignType.LinkedIn,
};

export const CampaignTypeToStringMap = {
  [CampaignType.Default]: 'Default',
  [CampaignType.Shopping]: 'Shopping',
  [CampaignType.DynamicSearchAds]: 'DynamicSearchAds',
  [CampaignType.Audience]: 'Audience',
  [CampaignType.Smart]: 'Smart',
  [CampaignType.Hotel]: 'Hotel',
  [CampaignType.PerformanceMax]: 'PerformanceMax',
  [CampaignType.App]: 'App',
  [CampaignType.LinkedIn]: 'LinkedIn',
  [CampaignType.All]: 'All',
};

export const CampaignTypeByODataValue = {
  Default: CampaignType.Default,
  Shopping: CampaignType.Shopping,
  DynamicSearchAds: CampaignType.DynamicSearchAds,
  Audience: CampaignType.Audience,
  Smart: CampaignType.Smart,
  Hotel: CampaignType.Hotel,
  PerformanceMax: CampaignType.PerformanceMax,
  App: CampaignType.App,
  LinkedIn: CampaignType.LinkedIn,
};
